import { EVENT_NAMES } from 'root/widgets';

import * as eventHandlers from './event-handlers';

const EVENT_MAP: Record<string, (context: any) => void> = {
  [EVENT_NAMES.GLOBAL_FOOTER.SOCIAL_ON_CLICK]: eventHandlers.handleGlobalFooterSocialClick,
  [EVENT_NAMES.GLOBAL_FOOTER.SITEMAP_LINK_ON_CLICK]: eventHandlers.handleGlobalFooterSitemapLinkClick,
};

export { EVENT_MAP };
